import { render } from "./UserInfo.vue?vue&type=template&id=e6462c6a&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=e6462c6a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6462c6a"]])

export default __exports__